import React, { Component } from "react";
import HtmlInput from '../html-input-component/htmlInput';
import ImageInput from '../image-input-component/imageInput';



class From extends Component {

	constructor(props) {
        super(props);
        this.save_process = false;
        this.fields = {};
        this.state = {
        	'rebuild' : 0
        };
    }


    async saveInfo () {
    	if ( this.save_process )
    		return false;

    	this.save_process = true;

    	if ( typeof(this.props.saveInfoCallback) === 'function' ) {
    		let json_data = {};
    		let form_data = new FormData();
    		let return_type = (typeof(this.props.formDataType) !== 'undefined') ? this.props.formDataType : 'json';
    		for ( let props_key in this.props.info ) {
    			let add_to_data = false;
    			let value_for_data = this.props.info[props_key];
    			if ( props_key === 'id' && parseInt(this.props.info[props_key]) ) {
	    			add_to_data = true;
	    		} else if ( typeof(this.fields[props_key]) !== 'undefined' ) {
    				let filed_type = this.fields[props_key];
    				switch ( filed_type ) {
	    				case 'input_image':
	    						if ( typeof(value_for_data) === 'object' ) {
	    							add_to_data = true;
	    						}
	    					break;

	    				default:
	    						add_to_data = true;
	    					break;
    				}
    			}

    			if ( add_to_data ) {
    				switch (return_type) {
	    				case 'FormData':
	    						form_data.append(props_key, value_for_data);
	    					break;

	    				default:
	    						json_data[props_key] = value_for_data;
	    					break;
    				}
    			}
    		}

    		let data = null;
    		switch (return_type) {
				case 'FormData':
						data = form_data;
					break;

				default:
						data = json_data;
					break;
			}

    		await this.props.saveInfoCallback( data );
    	}

    	this.save_process = false;
    }


    changeInfoValue ( prop_name, input_type, prop_value ) {
    	let rebuild = false;
    	let value = null;
    	switch ( input_type ) {
	    	case 'input_text':
	    	case 'input_textarea':
			case 'input_email':
	    	case 'input_select':
	    			value = prop_value.target.value;
	    		break;

	    	case 'input_checkbox':
	    			value = prop_value.target.checked ? 1 : 0;
	    		break;

	    	case 'input_html':
	    			value = prop_value;
	    		break;

	    	case 'input_image':
	    			value = prop_value;
	    			rebuild = true;
	    		break;

	    	default:
	    		break;
    	}
    	this.props.info[prop_name] = value;
    	if ( rebuild ) {
    		this.setState({
    			'rebuild' : this.state.rebuild + 1
    		});
    	}
    }


    renderSectionHtml ( section_key = '', section_props = {} ) {
    	let section_fields = [];
    	if ( typeof(section_props.fields) === 'object' ) {
    		for ( let field_key in section_props.fields ) {
    			let field = section_props.fields[field_key];
    			let field_label = field.label || '';
    			let field_name = field.name || field_key;
    			let field_type = field.type || 'input_text';
    			let field_html_key = 'form_field_' + field_key;
    			let field_wrrapper_class_name = field.wrapperClassName || 'form-group';
    			let field_class_name = field.className || 'form-control';
    			let field_default_value = this.props.info[field_name] || '';
    			if ( typeof(field.getDefaultValue) === 'function' ) {
    				field_default_value = field.getDefaultValue( field_default_value );
    			}

    			this.fields[field_name] = field_type;
    			switch (field_type) {
    				case 'input_select':
    						let options = field.options || {};
    						let select_options = [];
    						for ( let option_key in options ) {
    							select_options.push(<option 
    													key={field_html_key + 'form_option_' + option_key}
    													value={option_key}
    												>{options[option_key]}</option>);
    						}
    						section_fields.push(<div key={field_html_key} className={field_wrrapper_class_name}>
    							<label htmlFor={field_html_key}>{field_label}</label>
    							<select 
    								id={field_html_key}
    								type="text"
    								name={field_name}
    								className={field_class_name}
    								defaultValue={field_default_value}
    								onChange={this.changeInfoValue.bind(this, field_name, field_type)}
    							>{select_options}</select>
    						</div>);
    					break;

    				case 'input_text':
    						section_fields.push(<div key={field_html_key} className={field_wrrapper_class_name}>
    							<label htmlFor={field_html_key}>{field_label}</label>
    							<input 
    								id={field_html_key}
    								type="text"
    								name={field_name}
    								className={field_class_name}
    								defaultValue={field_default_value}
    								onChange={this.changeInfoValue.bind(this, field_name, field_type)}
    							/>
    						</div>);
    					break;

    				case 'input_textarea':
    						section_fields.push(<div key={field_html_key} className={field_wrrapper_class_name}>
    							<label htmlFor={field_html_key}>{field_label}</label>
    							<textarea 
    								id={field_html_key}
    								type="text"
    								name={field_name}
    								className={field_class_name}
    								defaultValue={field_default_value}
    								onChange={this.changeInfoValue.bind(this, field_name, field_type)}
    							></textarea>
    						</div>);
    					break;

					case 'input_email':
    						section_fields.push(<div key={field_html_key} className={field_wrrapper_class_name}>
    							<label  htmlFor={field_html_key}>{field_label}</label>
									<input 
	    								id={field_html_key}
	    								type="email"
	    								name={field_name}
											className={field_class_name}
	    								defaultValue={field_default_value}
	    								onChange={this.changeInfoValue.bind(this, field_name, field_type)}
	    							/>
    						</div>);
    					break;

    				case 'input_checkbox':
    						section_fields.push(<div key={field_html_key} className={field_wrrapper_class_name}>
    							<label>
	    							<input 
	    								id={field_html_key}
	    								type="checkbox"
	    								name={field_name}
	    								defaultChecked={field_default_value}
	    								onChange={this.changeInfoValue.bind(this, field_name, field_type)}
	    							/> {field_label}
    							</label>
    						</div>);
    					break;

    				case 'input_html':
    						section_fields.push(<div key={field_html_key} className={field_wrrapper_class_name}>
    							<HtmlInput 
				                    label={field_label}
				                    content={field_default_value}
				                    inputName={field_name}
				                    onChangeContent={function( input_name, content ){
				                    	this.changeInfoValue( input_name, 'input_html', content );
				                    }.bind(this)}
				                    withWrapper={false}
				                />
				            </div>);
    					break;

    				case 'input_image':
    						let image_name_key = field_name + '_name';
    						let image_name = this.props.info[image_name_key] || '';
    						section_fields.push(<div key={field_html_key} className={field_wrrapper_class_name}>
    							<ImageInput 
				                    label={field_label}
				                    fileImage={field_default_value}
				                    fileName={image_name}
				                    handleFile={function( file_name, file ){
				                    	// this.props.info[image_name_key] = file_name;
				                    	this.changeInfoValue( field_name, 'input_image', file );
				                    }.bind(this)}
				                    withWrapper={false}
				                />
				            </div>);
    					break;

    				default:
    					break;
    			}
    		}
    	}

    	return (<div key={"form_section_" + section_key}>
    		{section_fields}
    	</div>);
    }


	render () {
		let form = [];

		if ( typeof(this.props.sections) === 'object' ) {
			for ( let section_key in this.props.sections  ) {
				let section_html = this.renderSectionHtml(section_key, this.props.sections[section_key]);
				form.push( section_html );
			}
		}	

		let button_class_name = this.props.buttonClassName || 'btn btn-success';
		let button_label = this.props.buttonLabel || '';

		return (<>
			{form}
			<div className="form-group os-text-right">
                <button
                    className={button_class_name}
                    onClick={this.saveInfo.bind(this)}
                >
                    {button_label}
                </button>
            </div>
		</>);
	}

}


export default From;